<template>
  <div>
    <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">{{ $t("minimization.collect.text") }}</span>
        </template>

        <collect-minimization />
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">{{ $t("minimization.transfer.text") }}</span>
        </template>

        <transfer-minimization />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import CollectMinimization from "./collect-minimization";
import TransferMinimization from "./transfer-minimization";
export default { components: { CollectMinimization, TransferMinimization } };
</script>
